import { KEYS } from '../../../../../../../../../l18n/constants';
import { useL18nContext } from '../../../../../../../ContextProvider/L18n';
import computeClassName from '../../../../../../../../../utils/computeClassName';
import { usePartnerSearchContext } from '../../../../../../../ContextProvider/Partner/Search';
import PartnerTile from '../../Tile';
import Pagination from '../../../../../../../Pagination';

const constants = Object.freeze({
  CLASSNAME_BASE: 'border-t border-cc-gray-05 px-2 2xs:px-0 py-6'
});

export default function FoundPartners({className}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor } = useL18nContext();
  const translatedNoResultsFoundLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND);
  const {
    foundPartners,
    foundPartnerCount,
    selectedPartnerRoleCode,
    derivedSelectedPartnerRoleCode,
    isSearchByCombinedCriteriaFormSelected,
    currentPageIndex,
    recordCountPerPage,
    previousPage,
    nextPage
  } = usePartnerSearchContext();

  return (
    <div className={computedClassName}>
      {
        (!!foundPartners && !!foundPartners.length) &&
          <>
            <ul className="list-none grid grid-cols-1 3xs:grid-cols-2 xs:grid-cols-3 md:grid-cols-4 gap-6 mb-6 xs:mb-20">
              {
                foundPartners.map(
                  (foundPartner, index) => {
                    return (
                      <li key={index}>
                        <PartnerTile partner={foundPartner}
                                     selectedPartnerRoleCode={isSearchByCombinedCriteriaFormSelected() ? derivedSelectedPartnerRoleCode : selectedPartnerRoleCode}/>
                      </li>
                    )
                  })
              }
            </ul>

            <Pagination className="mb-4 xs:mb-12"
                        currentPageIndex={currentPageIndex}
                        nextPageFn={nextPage}
                        previousPageFn={previousPage}
                        recordCountPerPage={recordCountPerPage}
                        totalRecordCount={foundPartnerCount} />
          </>
      }
      {
        (!foundPartners || !foundPartners.length) &&
        <p className="text-center text-cc-200 text-cc-muted-contrast py-6">{translatedNoResultsFoundLabel}</p>
      }
    </div>
  );
}
